export const SECTION_ONE = [
  {
    title: '低预算',
    subTitle:
      '搭建社媒官⽅账号，针对不同⽤⼾，量化优秀内容生产标准，有策略的搭配服务产品，满足客⼾多场景需求',
  },
  {
    title: '多平台',
    subTitle:
      '市场调研+地域&⾏为筛选=⼈群策略精准定位，不断刷新媒介成功路径，快速占领用户心智',
  },
  {
    title: '高转化',
    subTitle: '以爆款逻辑持续做获客+转化，高频触达，突破流量层级，实现长尾收入',
  },
]
